
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"19","cy":"19","r":"19","fill":"red"}}),_c('path',{attrs:{"d":"M23.9 14.577a.98.98 0 100-1.962.98.98 0 000 1.962zM21.285 12.615a.98.98 0 100-1.961.98.98 0 000 1.961zM18.669 11.961a.98.98 0 100-1.961.98.98 0 000 1.961zM16.054 13.27a.98.98 0 100-1.962.98.98 0 000 1.961z","fill":"#fff"}}),_c('path',{attrs:{"d":"M22.92 13.615v4.25a.327.327 0 01-.655 0v-6.211h-1.961v5.558a.327.327 0 01-.654 0V11h-1.962v6.212a.327.327 0 01-.654 0v-4.904h-1.961v8.173l-1.324-1.812c-.392-.605-1.158-.808-1.72-.461-.558.354-.697 1.127-.31 1.73 0 0 2.136 3.232 3.046 4.616.91 1.383 2.384 2.465 5.142 2.465 4.565 0 4.974-3.525 4.974-4.577v-8.827h-1.962z","fill":"#fff"}})])
          )
        }
      }
    